<template>
  <path pid="0" d="M21.16 15.16a1 1 0 10-.5 1.94 3 3 0 012.25 2.9v2a1 1 0 002 0v-2a5 5 0 00-3.75-4.84zM16.66 10.91a1 1 0 10.5 1.94 5 5 0 000-9.69 1 1 0 10-.5 1.94 3 3 0 010 5.81zM1.91 23a1 1 0 001-1v-2a3 3 0 013-3h8a3 3 0 013 3v2a1 1 0 002 0v-2a5 5 0 00-5-5h-8a5 5 0 00-5 5v2a1 1 0 001 1zM9.91 13a5 5 0 10-5-5 5 5 0 005 5zm0-8a3 3 0 11-3 3 3 3 0 013-3z"/>
</template>
